/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetClientBalanceRequest as AgentApiContractGetClientBalanceRequest } from '../../models/AgentApi/Contract/get-client-balance-request';
import { GetClientBalanceResponse as AgentApiContractGetClientBalanceResponse } from '../../models/AgentApi/Contract/get-client-balance-response';

export interface ApiAgentGetClientBalancePost$Params {

/**
 * * Interface language
 */
  lang?: string;
      body?: AgentApiContractGetClientBalanceRequest
}

export function apiAgentGetClientBalancePost(http: HttpClient, rootUrl: string, params?: ApiAgentGetClientBalancePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractGetClientBalanceResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentGetClientBalancePost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractGetClientBalanceResponse>;
    })
  );
}

apiAgentGetClientBalancePost.PATH = '/api/Agent/GetClientBalance';
